export class ValueValidationError extends Error {
    value;
    messages;
    row;
    rowPos;
    constructor(value, messages, row, rowPos) {
        super(`Invalid #${rowPos} row in CSV: ${JSON.stringify(row)}`);
        this.value = value;
        this.messages = messages;
        this.row = row;
        this.rowPos = rowPos;
    }
}
//# sourceMappingURL=ValueValidationError.js.map